import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { updateProfile } from "./profiles"; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateFinancialSavingPattern = function updateFinancialSavingPattern(currentSavingPattern) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateFinancialSavingPattern',
    profileType: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
    data: {
      current_saving_pattern: currentSavingPattern
    },
    showMessages: showMessages,
    meta: {
      updating: 'current_saving_pattern'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateFinancialSpendingPattern = function updateFinancialSpendingPattern(currentSpendingPattern) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateFinancialSpendingPattern',
    profileType: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
    data: {
      current_spending_pattern: currentSpendingPattern
    },
    showMessages: showMessages,
    meta: {
      updating: 'current_spending_pattern'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateFinancialAmountOwed = function updateFinancialAmountOwed(amountOwed) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateFinancialAmountOwed',
    profileType: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
    data: {
      amount_owed: amountOwed
    },
    showMessages: showMessages,
    meta: {
      updating: 'amount_owed'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateFinancialDebtTypes = function updateFinancialDebtTypes(debtTypes) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateFinancialDebtTypes',
    profileType: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
    data: {
      debt_types: debtTypes
    },
    showMessages: showMessages,
    meta: {
      updating: 'debt_types'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateFinancialCreditScoreRange = function updateFinancialCreditScoreRange(creditScoreRange) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateFinancialCreditScoreRange',
    profileType: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
    data: {
      credit_score_range: creditScoreRange
    },
    showMessages: showMessages,
    meta: {
      updating: 'credit_score_range'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateFinancialAnnualIncome = function updateFinancialAnnualIncome(annualIncome) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateFinancialAnnualIncome',
    profileType: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
    data: {
      annual_income: annualIncome
    },
    showMessages: showMessages,
    meta: {
      updating: 'annual_income'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateOnboardingFinancialProfile = function updateOnboardingFinancialProfile(data) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateOnboardingFinancialProfile',
    profileType: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
    data: data,
    showMessages: showMessages,
    meta: {
      updating: 'financial_profile'
    }
  });
};